export function LoadingState() {
  return (
    <div>
      <div className="mb-2 h-0.5 w-full animate-pulse rounded bg-muted" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-[142px] animate-pulse rounded-xl bg-muted/40" />
        ))}
      </div>
    </div>
  );
}
